import _definePage_default_0 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/[...error].vue?definePage&vue&lang.tsx'
import { _mergeRouteRecord } from 'unplugin-vue-router/runtime'
import _definePage_default_2 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/administration/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_3 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/administration/new.vue?definePage&vue&lang.tsx'
import _definePage_default_4 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/administration/overview.vue?definePage&vue&lang.tsx'
import _definePage_default_5 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/airline-order/funnel/group.vue?definePage&vue&lang.tsx'
import _definePage_default_6 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/airline-order/funnel/select.vue?definePage&vue&lang.tsx'
import _definePage_default_7 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/airline-order/funnel/submit.vue?definePage&vue&lang.tsx'
import _definePage_default_8 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/airline-order/grouping/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_9 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/airline-order/grouping/overview.vue?definePage&vue&lang.tsx'
import _definePage_default_10 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/airline-order/overview.vue?definePage&vue&lang.tsx'
import _definePage_default_11 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/airline-order/pricing/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_12 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/airline-order/pricing/overview.vue?definePage&vue&lang.tsx'
import _definePage_default_13 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/airline-order/settings.vue?definePage&vue&lang.tsx'
import _definePage_default_14 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/error/401.vue?definePage&vue&lang.tsx'
import _definePage_default_15 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/error/404.vue?definePage&vue&lang.tsx'
import _definePage_default_16 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/forgot-password.vue?definePage&vue&lang.tsx'
import _definePage_default_17 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/login.vue?definePage&vue&lang.tsx'
import _definePage_default_18 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/not-authorized.vue?definePage&vue&lang.tsx'
import _definePage_default_19 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/packing-slip/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_20 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/packing-slip/new.vue?definePage&vue&lang.tsx'
import _definePage_default_21 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/packing-slip/overview.vue?definePage&vue&lang.tsx'
import _definePage_default_22 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/packing-slip/package/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_23 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/packing-slip/package/overview.vue?definePage&vue&lang.tsx'
import _definePage_default_24 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/packing-slip/settings.vue?definePage&vue&lang.tsx'
import _definePage_default_25 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/pricelist/bad-margin.vue?definePage&vue&lang.tsx'
import _definePage_default_26 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/pricelist/batch-updates.vue?definePage&vue&lang.tsx'
import _definePage_default_27 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/pricelist/margin-management.vue?definePage&vue&lang.tsx'
import _definePage_default_28 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/pricelist/overview.vue?definePage&vue&lang.tsx'
import _definePage_default_29 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/pricelist/pricing.vue?definePage&vue&lang.tsx'
import _definePage_default_30 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/pricelist/stale-debtor-prices.vue?definePage&vue&lang.tsx'
import _definePage_default_31 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/printing-order/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_32 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/printing-order/in_production.vue?definePage&vue&lang.tsx'
import _definePage_default_33 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/printing-order/new.vue?definePage&vue&lang.tsx'
import _definePage_default_34 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/printing-order/overview.vue?definePage&vue&lang.tsx'
import _definePage_default_35 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/printing-order/supplier/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_36 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/printing-order/supplier/overview.vue?definePage&vue&lang.tsx'
import _definePage_default_37 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/printing-order/waiting-for-approval.vue?definePage&vue&lang.tsx'
import _definePage_default_38 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/printing-order/waiting-for-sample.vue?definePage&vue&lang.tsx'
import _definePage_default_39 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/product/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_40 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/product/attribute/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_41 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/product/attribute/overview.vue?definePage&vue&lang.tsx'
import _definePage_default_42 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/product/overview.vue?definePage&vue&lang.tsx'
import _definePage_default_43 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/product/price-layer/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_44 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/product/price-layer/overview.vue?definePage&vue&lang.tsx'
import _definePage_default_45 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/register.vue?definePage&vue&lang.tsx'
import _definePage_default_46 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/user-profile/[id].vue?definePage&vue&lang.tsx'
import _definePage_default_47 from '/home/runner/work/bordex-tools/bordex-tools/client/src/pages/user-profile/overview.vue?definePage&vue&lang.tsx'

export const routes = [
  _mergeRouteRecord(
  {
    path: '/:error(.*)',
    name: '$error',
    component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/[...error].vue'),
    /* no children */
  },
  _definePage_default_0
  ),
  {
    path: '/account',
    /* internal name: 'account' */
    /* no component */
    children: [
      {
        path: ':id',
        name: 'account-id',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/account/[id].vue'),
        /* no children */
      },
      {
        path: 'me',
        name: 'account-me',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/account/me.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/administration',
    /* internal name: 'administration' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':id',
        name: 'administration-id',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/administration/[id].vue'),
        /* no children */
      },
  _definePage_default_2
  ),
  _mergeRouteRecord(
      {
        path: 'new',
        name: 'administration-new',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/administration/new.vue'),
        /* no children */
      },
  _definePage_default_3
  ),
  _mergeRouteRecord(
      {
        path: 'overview',
        name: 'administration-overview',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/administration/overview.vue'),
        /* no children */
      },
  _definePage_default_4
  )
    ],
  },
  {
    path: '/airline-order',
    /* internal name: 'airline-order' */
    /* no component */
    children: [
      {
        path: 'funnel',
        /* internal name: 'airline-order-funnel' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: 'group',
            name: 'airline-order-funnel-group',
            component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/airline-order/funnel/group.vue'),
            /* no children */
          },
  _definePage_default_5
  ),
  _mergeRouteRecord(
          {
            path: 'select',
            name: 'airline-order-funnel-select',
            component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/airline-order/funnel/select.vue'),
            /* no children */
          },
  _definePage_default_6
  ),
  _mergeRouteRecord(
          {
            path: 'submit',
            name: 'airline-order-funnel-submit',
            component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/airline-order/funnel/submit.vue'),
            /* no children */
          },
  _definePage_default_7
  )
        ],
      },
      {
        path: 'grouping',
        /* internal name: 'airline-order-grouping' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'airline-order-grouping-id',
            component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/airline-order/grouping/[id].vue'),
            /* no children */
          },
  _definePage_default_8
  ),
  _mergeRouteRecord(
          {
            path: 'overview',
            name: 'airline-order-grouping-overview',
            component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/airline-order/grouping/overview.vue'),
            /* no children */
          },
  _definePage_default_9
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'overview',
        name: 'airline-order-overview',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/airline-order/overview.vue'),
        /* no children */
      },
  _definePage_default_10
  ),
      {
        path: 'pricing',
        /* internal name: 'airline-order-pricing' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'airline-order-pricing-id',
            component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/airline-order/pricing/[id].vue'),
            /* no children */
          },
  _definePage_default_11
  ),
  _mergeRouteRecord(
          {
            path: 'overview',
            name: 'airline-order-pricing-overview',
            component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/airline-order/pricing/overview.vue'),
            /* no children */
          },
  _definePage_default_12
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'settings',
        name: 'airline-order-settings',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/airline-order/settings.vue'),
        /* no children */
      },
  _definePage_default_13
  )
    ],
  },
  {
    path: '/dashboard',
    name: 'dashboard',
    component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/dashboard.vue'),
    /* no children */
  },
  {
    path: '/dashboards',
    /* internal name: 'dashboards' */
    /* no component */
    children: [
      {
        path: 'analytics',
        name: 'dashboards-analytics',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/dashboards/analytics.vue'),
        /* no children */
      },
      {
        path: 'crm',
        name: 'dashboards-crm',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/dashboards/crm.vue'),
        /* no children */
      },
      {
        path: 'ecommerce',
        name: 'dashboards-ecommerce',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/dashboards/ecommerce.vue'),
        /* no children */
      }
    ],
  },
  {
    path: '/error',
    /* internal name: 'error' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: '401',
        name: 'error401',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/error/401.vue'),
        /* no children */
      },
  _definePage_default_14
  ),
  _mergeRouteRecord(
      {
        path: '404',
        name: 'error404',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/error/404.vue'),
        /* no children */
      },
  _definePage_default_15
  )
    ],
  },
  _mergeRouteRecord(
  {
    path: '/forgot-password',
    name: 'forgot-password',
    component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/forgot-password.vue'),
    /* no children */
  },
  _definePage_default_16
  ),
  _mergeRouteRecord(
  {
    path: '/login',
    name: 'login',
    component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/login.vue'),
    /* no children */
  },
  _definePage_default_17
  ),
  _mergeRouteRecord(
  {
    path: '/not-authorized',
    name: 'not-authorized',
    component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/not-authorized.vue'),
    /* no children */
  },
  _definePage_default_18
  ),
  {
    path: '/packing-slip',
    /* internal name: 'packing-slip' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':id',
        name: 'packing-slip-id',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/packing-slip/[id].vue'),
        /* no children */
      },
  _definePage_default_19
  ),
  _mergeRouteRecord(
      {
        path: 'new',
        name: 'packing-slip-new',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/packing-slip/new.vue'),
        /* no children */
      },
  _definePage_default_20
  ),
  _mergeRouteRecord(
      {
        path: 'overview',
        name: 'packing-slip-overview',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/packing-slip/overview.vue'),
        /* no children */
      },
  _definePage_default_21
  ),
      {
        path: 'package',
        /* internal name: 'packing-slip-package' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'packing-slip-package-id',
            component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/packing-slip/package/[id].vue'),
            /* no children */
          },
  _definePage_default_22
  ),
  _mergeRouteRecord(
          {
            path: 'overview',
            name: 'packing-slip-package-overview',
            component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/packing-slip/package/overview.vue'),
            /* no children */
          },
  _definePage_default_23
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'settings',
        name: 'packing-slip-settings',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/packing-slip/settings.vue'),
        /* no children */
      },
  _definePage_default_24
  )
    ],
  },
  {
    path: '/pricelist',
    /* internal name: 'pricelist' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: 'bad-margin',
        name: 'pricelist-bad-margin',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/pricelist/bad-margin.vue'),
        /* no children */
      },
  _definePage_default_25
  ),
  _mergeRouteRecord(
      {
        path: 'batch-updates',
        name: 'pricelist-batch-updates',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/pricelist/batch-updates.vue'),
        /* no children */
      },
  _definePage_default_26
  ),
  _mergeRouteRecord(
      {
        path: 'margin-management',
        name: 'pricelist-margin-management',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/pricelist/margin-management.vue'),
        /* no children */
      },
  _definePage_default_27
  ),
  _mergeRouteRecord(
      {
        path: 'overview',
        name: 'pricelist-overview',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/pricelist/overview.vue'),
        /* no children */
      },
  _definePage_default_28
  ),
  _mergeRouteRecord(
      {
        path: 'pricing',
        name: 'pricelist-pricing',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/pricelist/pricing.vue'),
        /* no children */
      },
  _definePage_default_29
  ),
  _mergeRouteRecord(
      {
        path: 'stale-debtor-prices',
        name: 'pricelist-stale-debtor-prices',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/pricelist/stale-debtor-prices.vue'),
        /* no children */
      },
  _definePage_default_30
  )
    ],
  },
  {
    path: '/printing-order',
    /* internal name: 'printing-order' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':id',
        name: 'printing-order-id',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/printing-order/[id].vue'),
        /* no children */
      },
  _definePage_default_31
  ),
  _mergeRouteRecord(
      {
        path: 'in_production',
        name: 'printing-order-in-production',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/printing-order/in_production.vue'),
        /* no children */
      },
  _definePage_default_32
  ),
  _mergeRouteRecord(
      {
        path: 'new',
        name: 'printing-order-new',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/printing-order/new.vue'),
        /* no children */
      },
  _definePage_default_33
  ),
  _mergeRouteRecord(
      {
        path: 'overview',
        name: 'printing-order-overview',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/printing-order/overview.vue'),
        /* no children */
      },
  _definePage_default_34
  ),
      {
        path: 'supplier',
        /* internal name: 'printing-order-supplier' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'printing-order-supplier-id',
            component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/printing-order/supplier/[id].vue'),
            /* no children */
          },
  _definePage_default_35
  ),
  _mergeRouteRecord(
          {
            path: 'overview',
            name: 'printing-order-supplier-overview',
            component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/printing-order/supplier/overview.vue'),
            /* no children */
          },
  _definePage_default_36
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'waiting-for-approval',
        name: 'printing-order-waiting-for-approval',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/printing-order/waiting-for-approval.vue'),
        /* no children */
      },
  _definePage_default_37
  ),
  _mergeRouteRecord(
      {
        path: 'waiting-for-sample',
        name: 'printing-order-waiting-for-sample',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/printing-order/waiting-for-sample.vue'),
        /* no children */
      },
  _definePage_default_38
  )
    ],
  },
  {
    path: '/product',
    /* internal name: 'product' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':id',
        name: 'product-id',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/product/[id].vue'),
        /* no children */
      },
  _definePage_default_39
  ),
      {
        path: 'attribute',
        /* internal name: 'product-attribute' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'product-attribute-id',
            component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/product/attribute/[id].vue'),
            /* no children */
          },
  _definePage_default_40
  ),
  _mergeRouteRecord(
          {
            path: 'overview',
            name: 'product-attribute-overview',
            component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/product/attribute/overview.vue'),
            /* no children */
          },
  _definePage_default_41
  )
        ],
      },
  _mergeRouteRecord(
      {
        path: 'overview',
        name: 'product-overview',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/product/overview.vue'),
        /* no children */
      },
  _definePage_default_42
  ),
      {
        path: 'price-layer',
        /* internal name: 'product-price-layer' */
        /* no component */
        children: [
  _mergeRouteRecord(
          {
            path: ':id',
            name: 'product-price-layer-id',
            component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/product/price-layer/[id].vue'),
            /* no children */
          },
  _definePage_default_43
  ),
  _mergeRouteRecord(
          {
            path: 'overview',
            name: 'product-price-layer-overview',
            component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/product/price-layer/overview.vue'),
            /* no children */
          },
  _definePage_default_44
  )
        ],
      }
    ],
  },
  _mergeRouteRecord(
  {
    path: '/register',
    name: 'register',
    component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/register.vue'),
    /* no children */
  },
  _definePage_default_45
  ),
  {
    path: '/tools',
    /* internal name: 'tools' */
    /* no component */
    children: [
      {
        path: '',
        name: 'tools',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/tools/index.vue'),
        /* no children */
        meta: {
          "navActiveLink": "tools",
          "requiresAuth": true,
          "icon": "tabler-tools",
          "title": "Tools"
        }
      },
      {
        path: 'quotation',
        name: 'tools-quotation',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/tools/quotation.vue'),
        /* no children */
        meta: {
          "navActiveLink": "tools-quotation",
          "requiresAuth": true,
          "icon": "tabler-file-text",
          "title": "Quotation tool"
        }
      },
      {
        path: 'transsmart',
        name: 'tools-transsmart',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/tools/transsmart.vue'),
        /* no children */
        meta: {
          "navActiveLink": "tools-transsmart",
          "requiresAuth": true,
          "icon": "tabler-truck",
          "title": "Transmart-AFAS Sync"
        }
      }
    ],
  },
  {
    path: '/user-profile',
    /* internal name: 'user-profile' */
    /* no component */
    children: [
  _mergeRouteRecord(
      {
        path: ':id',
        name: 'user-profile-id',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/user-profile/[id].vue'),
        /* no children */
      },
  _definePage_default_46
  ),
  _mergeRouteRecord(
      {
        path: 'overview',
        name: 'user-profile-overview',
        component: () => import('/home/runner/work/bordex-tools/bordex-tools/client/src/pages/user-profile/overview.vue'),
        /* no children */
      },
  _definePage_default_47
  )
    ],
  }
]

export function handleHotUpdate(_router) {
  if (import.meta.hot) {
    import.meta.hot.data.router = _router
  }
}

if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    if (!router) {
      import.meta.hot.invalidate('[unplugin-vue-router:HMR] Cannot replace the routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    for (const route of mod.routes) {
      router.addRoute(route)
    }
    router.replace('')
  })
}

